import { AkukoAPIService } from './serviceClass';
import { Dictionary } from '@onaio/utils';
import { IDENTITY_API } from '../configs/env';
import { PostFolder } from '../types/postFolders';

export interface FolderPermission {
  user_id?: string;
  group_id?: string;
  role: 'admin' | 'edit' | 'view';
}

export interface UpdateFolderRequest {
  name: string;
}

export class PostFolderService extends AkukoAPIService {
  constructor(url: string) {
    super(IDENTITY_API, url);
  }

  async createRootFolder(name: string): Promise<PostFolder> {
    const data: Dictionary<string> = { name };
    return this.create(data) as Promise<PostFolder>;
  }

  async createChildFolder(name: string, parentId: string): Promise<PostFolder> {
    const data: Dictionary<string> = { name, parent_id: parentId };
    return this.create(data) as Promise<PostFolder>;
  }

  async listFolders(parentFolderId?: string): Promise<PostFolder[]> {
    const params = parentFolderId ? { parent_folder_id: parentFolderId } : undefined;
    return this.list(params) as Promise<PostFolder[]>;
  }

  async getFolderDetails(folderId: string): Promise<PostFolder> {
    return this.read(folderId) as Promise<PostFolder>;
  }

  async updateFolder(data: UpdateFolderRequest): Promise<PostFolder> {
    return this.update(data) as Promise<PostFolder>;
  }

  async deleteFolder(): Promise<void> {
    return this.delete() as Promise<void>;
  }

  async assignUser(permission: FolderPermission) {
    return this.create(permission, undefined, 'PATCH');
  }

  async assignGroup(permission: FolderPermission) {
    return this.create(permission, undefined, 'PATCH');
  }

  async removeUser() {
    return this.delete();
  }

  async removeGroup() {
    return this.delete();
  }
}

export default PostFolderService; 